import CarouselDisplayTrigger from '@alltrails/amplitude/enums/CarouselDisplayTrigger';

const getInstallInterstitialVariantByTrigger = (trigger?: CarouselDisplayTrigger) => {
  if (trigger === 'Hit the Trail Card Download Map') {
    return 'download';
  }
  if (trigger === 'Hit the Trail Card Navigate') {
    return 'navigate';
  }
  if (trigger === 'Hit the Trail Card Live Share') {
    return 'liveshare';
  }
  return 'generic';
};

export default getInstallInterstitialVariantByTrigger;
